import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import React, { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AlertsContext from "common/providers/alerts";
import MarkerForm from "./MarkerForm";

function Marker() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "markers",
    id,
    { populate: ["image", "organization"] }
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/markers");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataMarker: any) => {
      const marker = { ...dataMarker };

      try {
        if (marker.id) {
          await updateItem(marker.id, marker);
        } else {
          await saveItem(marker);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <MarkerForm onSubmit={onSubmit} marker={item} />
  );
}

export default Marker;
